import { login, logout, getInfo, getUserInfoLatest } from '@/api/user'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { setUserIdAsAlias, clearUserIdAlias } from '@/utils/push'

const state = {
  token: getToken(),
  id: '',
  name: '',
  userInfo: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_USER_INFO: (state, info) => {
    state.userInfo = info
    state.id = info.id
    state.name = info.nickname
  }
}

const actions = {
  // 登录
  login({ commit }, userInfo) {
    const { mobile, yzm } = userInfo
    return new Promise((resolve, reject) => {
      login({ mobile, yzm })
        .then(res => {
          const { data } = res
          commit('SET_TOKEN', data)
          setToken(data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 登出
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          commit('SET_TOKEN', '')
          removeToken()
          
          // 清除推送别名
          clearUserIdAlias()
            .then(() => {
              console.log('用户登出，已清除推送别名')
            })
            .catch(error => {
              console.warn('清除推送别名失败:', error.message)
            })

          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 获取基本用户信息
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token)
        .then(res => {
          const data = res.data
          if (!data) {
            reject(new Error('获取基本信息失败，请重新登录'))
          }
          commit('SET_USER_INFO', data)
          
          // 设置用户ID为推送别名
          if (data && data.id) {
            setUserIdAsAlias(data.id.toString())
              .then(() => {
                console.log('用户信息获取成功，已设置推送别名:', data.id)
              })
              .catch(error => {
                console.warn('设置推送别名失败:', error.message)
              })
          }
          
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  /**
   * 用 DB 最新设备权限字段覆盖本地 userInfo 中对应字段
   * （不写 Redis，仅更新 Vuex 中 isMushroomUser / isNewMushRoomUser / isAllMushRoomUser）
   * 后台改方舱权限后进智控前调用，无需重新登录
   */
  syncUserInfoLatest({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfoLatest()
        .then(res => {
          const data = res.data
          if (!data) {
            reject(new Error('同步用户信息失败'))
            return
          }
          const merged = {
            ...state.userInfo,
            isMushroomUser: data.isMushroomUser,
            isNewMushRoomUser: data.isNewMushRoomUser,
            isAllMushRoomUser: data.isAllMushRoomUser,
            userPermission: data.userPermission
          }
          commit('SET_USER_INFO', merged)
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // 重置token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
